export default "__VITE_ASSET__Cu0JoRdV__"